import { SocialActionEnum } from "./type";
import SocialService from "../../../api/SocialService";

export const SocialActionCreators = {
  setIsConnectButtonClicked: (payload: boolean) => ({
    type: SocialActionEnum.SET_CLICK_BUTTON,
    payload,
  }),
  setResultSlider: (payload: number) => ({
    type: SocialActionEnum.SET_RESULT,
    payload,
  }),
  setIsAddresConnected: (payload: boolean) => ({
    type: SocialActionEnum.SET_ISADDRES,
    payload,
  }),
  setToken: (payload: string) => ({
    type: SocialActionEnum.SET_TOKEN,
    payload,
  }),
  setWallet: (payload: string) => ({
    type: SocialActionEnum.SET_WALLET_ID,
    payload,
  }),
  setSocialSubscription: (payload: boolean) => ({
    type: SocialActionEnum.SET_TELEGRAM_SUBSCRIPTION,
    payload,
  }),
  connectUserInNetwork: (newtWorkId: string, walletId: string) => async () => {
    try {
      return await SocialService.connectUserInNetwork(newtWorkId, walletId);
    } catch (e) {
      console.log(e);
    }
  },
  setSliderIndex: (payload: number) => ({
    type: SocialActionEnum.SET_SLIDER_INDEX,
    payload,
  }),
  setDiasbeldTab: (payload: boolean) => ({
    type: SocialActionEnum.SET_DISABELD_TAB,
    payload,
  }),
  setAccountLocal: (payload: string) => ({
    type: SocialActionEnum.SET_ACCOUNT_LOCAL,
    payload,
  }),
  setClickedBuySweet: (payload: boolean) => ({
    type: SocialActionEnum.SET_CLICKED_BUY,
    payload,
  }),
  setBalance: (payload: any) => ({
    type: SocialActionEnum.SET_BALANCE,
    payload,
  }),
  setBusdBalance: (payload: number) => ({
    type: SocialActionEnum.SET_BUSD_COIN,
    payload,
  }),
  setSweetPresaleBalance: (payload: number | string) => ({
    type: SocialActionEnum.SET_SWEET_PRESALAE_COIN,
    payload,
  }),
  setAccountSweetBalance: (payload: number | string) => ({
    type: SocialActionEnum.SET_ACCOUNT_SWEET,
    payload,
  }),
  setBnbBalance: (payload: number | string) => ({
    type: SocialActionEnum.SET_BNB_BALANCE,
    payload,
  }),
  setProvider: (payload: any) => ({
    type: SocialActionEnum.SET_PROVIDER,
    payload,
  }),
  setOpenBurgerMenu: (payload: boolean) => ({
    type: SocialActionEnum.SET_OPEN_BURGER_MENU,
    payload,
  }),
  setOpenDrawerMenu: (payload: boolean) => ({
    type: SocialActionEnum.SET_OPEN_DRAWWER_MENU,
    payload,
  }),
  setUserNfts: (payload: any) => ({
    type: SocialActionEnum.SET_USER_NFTS,
    payload,
  }),
  setCurrentBlock: (payload: number | null) => ({
    type: SocialActionEnum.SET_CURRENT_BLOCK,
    payload,
  }),
  setFreezesBlock: (payload: Array<[]>) => ({
    type: SocialActionEnum.SET_FREEZES_BLOCK,
    payload,
  }),
  setFreezesNftID: (payload: Array<[]>) => ({
    type: SocialActionEnum.SET_FREEZES_NFT_ID,
    payload,
  }),
  setFreezesNft: (payload: Array<[]>) => ({
    type: SocialActionEnum.SET_FREEZES_NFT,
    payload,
  }),
  setConnected: (payload: boolean) => ({
    type: SocialActionEnum.SET_ACCOUNT_CONNECTED,
    payload,
  }),
  setSweetFreezeCountBalance: (payload: number | string) => ({
    type: SocialActionEnum.GET_SWEET_FREEZE_CARD_BALANCE,
    payload,
  }),
  setUsersStakers: (payload: any) => ({
    type: SocialActionEnum.SET_STAKES_USERS,
    payload,
  }),
  setFreezeInfo: (payload: any) => ({
    type: SocialActionEnum.SET_FREEZE_INFO,
    payload,
  }),
};
